import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Bell, CheckCheck, Info, AlertTriangle, CheckCircle, Zap } from 'lucide-react';
import toast from 'react-hot-toast';

const typeIcons = { info: Info, warning: AlertTriangle, alert: AlertTriangle, success: CheckCircle, milestone: Zap, task: CheckCircle, message: Bell };

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/notifications'),
      api.get('/notifications/unread-count'),
    ]).then(([notifRes, countRes]) => {
      setNotifications(notifRes.data || []);
      setUnread(countRes.data.count || 0);
    }).catch(() => { }).finally(() => setLoading(false));
  }, []);

  const markRead = async (id) => {
    try {
      await api.put(`/notifications/${id}/read`);
      setNotifications(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
      setUnread(prev => Math.max(0, prev - 1));
    } catch (e) { /* ignore */ }
  };

  const markAllRead = async () => {
    try {
      await api.put('/notifications/read-all');
      setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
      setUnread(0);
      toast.success('Todas leídas');
    } catch (e) { toast.error('Error'); }
  };

  return (
    <div className="page-notifications">
      <div className="page-header">
        <div><h1>Notificaciones</h1><p className="subtitle">{unread} sin leer</p></div>
        {unread > 0 && <button className="btn btn-secondary" onClick={markAllRead}><CheckCheck size={18} /> Marcar todas leídas</button>}
      </div>
      {loading ? <div className="loading-screen"><div className="spinner" /></div> : (
        <div className="notifications-list">
          {notifications.map(n => {
            const Icon = typeIcons[n.type] || Bell;
            return (
              <div key={n.id} className={`notif-item ${n.is_read ? 'read' : 'unread'}`} onClick={() => !n.is_read && markRead(n.id)}>
                <div className={`notif-icon ${n.type}`}><Icon size={18} /></div>
                <div className="notif-content">
                  <span className="notif-title">{n.title}</span>
                  {n.body && <p className="notif-body">{n.body}</p>}
                  <span className="notif-time">{new Date(n.created_at).toLocaleString('es')}</span>
                </div>
                {!n.is_read && <span className="notif-dot" />}
              </div>
            );
          })}
          {notifications.length === 0 && <div className="empty-state"><Bell size={48} /><p>No hay notificaciones</p></div>}
        </div>
      )}
    </div>
  );
}
